import styled from "styled-components";

// TEXT

// STYLES
export const ModalContent = styled.div`
  gap: 1.5rem;
  display: flex;
  flex-direction: column;
  padding: 1.5rem 1.5rem 0;
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
